import Grid from '@mui/material/Grid';

const EpisodeHeader = (props) => {
  const {
    data
  } = props;

  return (
      <>
      <Grid item xs={2} style={{  }}>
        Participant
      </Grid>
      <Grid item xs={1} style={{  }}>
        CDC #
      </Grid>
      <Grid item xs={1} style={{  }}>
        Gender
      </Grid>
      <Grid item xs={.5} style={{  }}>
        290
      </Grid>
      <Grid item xs={.75} style={{  }}>
        CCMS
      </Grid>
      <Grid item xs={1.25} style={{  }}>
        EPRD
      </Grid>
      <Grid item xs={1.5} style={{  }}>
        Parole Cnty
      </Grid>
      <Grid item xs={1.5} style={{  }}>
        Ref SAP
      </Grid>
      <Grid item xs={2} style={{  }}>
        CM
      </Grid>
      <Grid item xs={2} style={{ color: 'blue' }}>
        {data.key}
      </Grid>
      <Grid item xs={1} style={{  }} style={{ color: 'blue' }}>
        {data.cDCNumber}
      </Grid>
      <Grid item xs={1} style={{  }} style={{ color: 'blue' }}>
        {data.gender}
      </Grid>
      <Grid item xs={.5} style={{  }} style={{ color: 'blue' }}>
        {data.registration290 ? 'Y' : 'N'}
      </Grid>
      <Grid item xs={.75} style={{  }} style={{ color: 'blue' }}>
        {data.cCCMS ? 'Y' : 'N'}
      </Grid>
      <Grid item xs={1.25} style={{  }} style={{ color: 'blue' }}>
        {data.expectedEPRD}
      </Grid>
      <Grid item xs={1.5} style={{  }} style={{ color: 'blue' }}>
        {data.paroleCounty}
      </Grid>
      <Grid item xs={1.5} style={{  }} style={{ color: 'blue' }}>
        {data.referralSource}
      </Grid>
      <Grid item xs={2} style={{  }} style={{ color: 'blue' }}>
        {data.caseManager}
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
      </>

  );
}  

export default EpisodeHeader;
